import { AgeCoefficients, AgeThresholds } from '../constants/Age';

export const getAgeCoefficient = (age: number) => {
    let coefIndex = AgeThresholds.findIndex((thr) => age < thr);
    if (coefIndex < 0) {
        coefIndex = AgeCoefficients.length - 1;
    }
    return AgeCoefficients[coefIndex];
};
